import { ElementsGroup, Typography } from '@otp/ui';

export const DevicesField = ({ devices }: { devices: string[] }) => (
  <ElementsGroup
    elements={devices.map((device) => (
      <Typography key={device} variant="subtitle1">
        {device}
      </Typography>
    ))}
    limit={1}
  />
);
